import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { ErrorHandlerService } from '@inera/common';

@Injectable()
export class IdpErrorHandlerService extends ErrorHandlerService {
  private router = inject(Router);

  error(error: any): Observable<any> {
    const displayValues = this.getDisplayValues(error);
    let sessionid = '';
    let dateTime = '';
    if (error.error != null) {
      sessionid = error.error.id;
      dateTime = error.error.dateTime;
    }

    switch (error.status) {
      case 401:
        if (displayValues.messages.includes('No HTTP session')) {
          this.router.navigate(['/loggedout'], {
            queryParams: {
              message: 'sessiontimeout'
            }
          });
        }
        break;

      case 418:
        // I'm a teapot, we use this errorcode to redirect the user to an angular-external url
        window.location.assign(error.error.redirectURL);
        return throwError(displayValues);

      default:
        this.router.navigate(['_error'], {
          queryParams: {
            id: sessionid,
            status: error.status,
            error: displayValues.error,
            message: displayValues.messages[0],
            datetime: encodeURIComponent(dateTime)
          }
        });
        break;
    }

    return throwError(displayValues);
  }
}
